(function (window, app, overwatch) {

    var esports = {
        init: function() {
            this.setupVideoAnalytics();
            window.overwatch.slideout.init();
            window.overwatch.slideout.openSlideout('openDivision');
            window.app.horizontalAccordion.init($('[data-id="esports-pathtopro-accordion"]'));
        },
        setupVideoAnalytics: function() {
            $('[data-js-youtube-player]').on('click', function() {
                var videoID = $(this).data('yt-id');
                if (window.dataLayer) {
                    window.dataLayer.push({
                        event: 'videoClick',
                        videoID: videoID,
                        dataAnalyticsPlacement: 'esports-trailer'
                    });
                };
            });
        }
    };
    app.extend({
        esports: esports
    });
}(window, window.app, window.overwatch));
